import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { IDocumentCard } from '../../../interfaces/document-card.interface';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../../services/http.service';
import { Router } from '@angular/router';
import { GtmService } from '../../../services/gtm.service';

@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [CommonModule, NzDividerModule, NzIconModule, TranslateModule],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SummaryComponent implements OnInit {
  @Input() diagnosis: any;
  emergencyForm?: FormGroup;
  countryList: any[] = [];
  countryDescriptions: string[] = [];
  countryIds: string[] = [];
  selectedCountryNumber: string | null = null;
  onMobile : boolean = false;

  documentCardMock: IDocumentCard = {
    /* TODO Remove mock */
    id: 'id',
    icon: 'file-icon.svg',
    title: 'document.documentName',
    date: "format(new Date(document.documentDate), 'dd MM yyyy')",
    type: 'document.type',
    additional_text: 'reportsPage.document_type',
  };

  constructor(
    private fb: FormBuilder,
    private http: HttpService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private gtmService: GtmService
  ) {}

  ngOnInit(): void {
    this.onMobile = window.innerWidth <= 768; 
    this.emergencyForm = this.fb.group({
      destination: [null, Validators.required],
    });
    this.fetchCountryData();
  }

  fetchCountryData() {
    this.http.getEmergencyNumber().subscribe(
      (response) => {
        this.countryList = response;
        this.countryDescriptions = this.countryList.map((country) => `${country.countryName} - ${country.numberDescription} (${country.number})`);
        this.countryIds = this.countryList.map((country) => country.id);
      },
      (error) => {
        console.error('Errore durante il recupero dei dati:', error);
      }
    );

    this.emergencyForm?.get('destination')?.valueChanges.subscribe((value) => {
      this.updateSelectedCountry(value);
      this.cdr.detectChanges();
    });
  }

  updateSelectedCountry(selectedId: any) {
    const selectedCountry = this.countryList.find((country) => country.id === selectedId);
    this.selectedCountryNumber = selectedCountry ? selectedCountry.number : null;
  }

  callToEmergency() {
    if (this.selectedCountryNumber) {
      this.router.navigate([`tel:${this.selectedCountryNumber}`]);
    }
  }

  protected medicalConsultation(): void {
    this.router.navigate(['/medical-consultations']);
  }

  protected back(): void {
    this.gtmService.pushSymptomAssessmentEvent('symptom_assessment_success');
    this.router.navigate(['/symptom-assessment']);
  }

  printSection(): void {
    const printContent = document.getElementById('print-section');
    const WindowPrt = window.open('', '', 'width=800,height=600');

    if (WindowPrt && printContent) {
      WindowPrt.document.write(`
        <html>
          <head>
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
              }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
        </html>
      `);
      WindowPrt.document.close();
      WindowPrt.focus();
      WindowPrt.print();
      WindowPrt.close();
    }
  }
}
